








import { computed, defineComponent } from '@vue/composition-api';
export default defineComponent({
	props: {
		mapId: {
			type: String,
			required: true,
		},
		fieldId: {
			type: String,
			required: true,
		},
		coordinates: {
			type: Array as () => number[] | null,
		},
	},
	setup({ mapId, fieldId, coordinates }, { root }) {
		const isActive = computed<boolean>(() => {
			const activeFieldId = root.$store.getters['fieldsView/getActiveFieldId'];
			return activeFieldId === fieldId;
		});
		const buttonColor = computed<string>(() => (isActive.value ? 'primary' : ''));

		const handleClick = (ev: MouseEvent | TouchEvent) => {
			ev.preventDefault();
			ev.stopPropagation();

			// Set active field row
			if (!isActive.value) {
				root.$store.dispatch('fieldsView/setActiveFieldId', fieldId);
			}

			// Set pan marker
			if (coordinates) {
				root.$store.dispatch('map/setPointToFly', { mapId, coordinates });
			}
		};

		return {
			buttonColor,
			handleClick,
		};
	},
});
